export default __webpack_public_path__ + "static/media/image2.58800015.webp";